const ExtAres = {
    init: function () {
        const tlaciktoAres = $("#tlacitko-ares");
        if (!tlaciktoAres.length) {
            return;
        }

        tlaciktoAres
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                ExtAres.vyhledejSubjekt();
            });
    },

    vyhledejSubjekt: function () {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/ares/vyhledejSubjekt";

        const _ch = $("#_ch");
        if (!_ch.length) {
            return;
        }

        const ico = $("#subjektico");
        if (!ico.length) {
            return;
        }

        $.ajax({
            type: "post",
            url: url,
            data: {"_ch": _ch.val(), "ico": ico.val()},
            dataType: "json",
            global: false,
            beforeSend: function () {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Vyhledávám subjekt ...", "subjektSearchBeforeSend");
            },
            complete: function () {
                Lemo_Alert.closeById("subjektSearchBeforeSend");
            },
            success: function (r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                const aresInfo = $("#ares-info-text");
                if (aresInfo.length) {
                    aresInfo.remove();
                }

                if (r.hasOwnProperty("status") && true === r.status) {
                    if (r.hasOwnProperty("data")) {
                        const data = r["data"];
                        ExtAres.modalVyberAkce(data);
                    }
                }
            },
            error: function () {
                Lemo_Alert.addDanger("Vyhledání subjektu selhalo.", "subjektSearchError");
            }
        });
    },

    modalVyberAkce: function (data) {
        let rozdily = "";
        const typ = $("#subjekttyp");
        const nazev = $("#subjektnazev");
        const dic = $("#subjektdic");
        const jmeno = $("#subjektjmeno");
        const prijmeni = $("#subjektprijmeni");

        if (parseInt(typ.val()) !== parseInt(data['subjekttyp'])) {
            rozdily += "Typ subjektu<br>";
        }

        if (nazev.val() !== data['subjektnazev']) {
            rozdily += "Název subjektu: " + data['subjektnazev'] + "<br>";
        }

        if (
            dic.val() !== data['subjektdic'] && data['subjektdic'] !== null
            || dic.val() !== '' && data['subjektdic'] === null
        ) {
            rozdily += "DIČ: " + data['subjektdic'] + "<br>";
        }

        if (data["oficialniAdresa"]) {
            rozdily += data['oficialniAdresa'] + "<br>";
            rozdily += "Kód adresy: " + data['kodadresy'] + "<br>";
        }

        let content = '<p class="text text-center font-weight-bold">Subjekt byl úspěšně vyhledán v registru.</p>';
        if (rozdily.length) {
            content += '<div class="text-center">';
            content += '  <i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
            content += '</div>';

            content += '<p class="text text-center font-weight-bold">';
            content += '  Údaje uvedené v registru se liší od zadaných.<br>';
            content += '  Hodnoty můžete nahradit pomocí tlačítka "Přepsat",<br>';
            content += '  skutečně nahrazeny budou až po uložení žádosti.<br>';
            content += '</p>';

            content += '<p class="text text-center font-weight-bold">';
            content += rozdily;
            content += '</p>';
        } else {
            content += '<div class="text-center">';
            content += '  <i class="fa fa-check-circle fa-fw fa-5x mt-3 mb-4 text-success"></i>';
            content += '</div>';

            content += '<p class="text text-center font-weight-bold">';
            content += '  Údaje uvedené v registru se shodují se zadanými.<br>';
            content += '</p>';
        }

        WilleModal.setTitle('ARES');
        WilleModal.disableClose();

        if (rozdily.length) {
            WilleModal.addButton(
                "continue",
                "<i class=\"fa fa-fw fa-pencil\"></i> Přepsat",
                "btn btn-primary",
                function () {
                    typ.val(data["subjekttyp"]);
                    typ.trigger('change');
                    nazev.val(data["subjektnazev"])
                    dic.val(data["subjektdic"]);

                    if (data["subjektjmeno"]) {
                        jmeno.val(data["subjektjmeno"])
                    }

                    if (data["subjektprijmeni"]) {
                        prijmeni.val(data["subjektprijmeni"])
                    }

                    Promise.all([
                        WilleModal.close()
                    ]).then(() => {
                        if (data["oficialniAdresa"] && data["kodadresy"]) {
                            DpoXrn.doplnAdresu(data['kodadresy']);
                        }
                        Lemo_Alert.closeAll();
                    }).catch((messages) => {
                        console.log(messages);
                    });
                });
        }

        WilleModal.addButton("cancel",
            "<i class=\"fa fa-fw fa-times\"></i> Zavřít",
            'btn btn-danger',
            function () {
                Promise.all([
                    WilleModal.close()
                ]).then(() => {
                    Lemo_Alert.closeAll();
                }).catch((messages) => {
                    console.log(messages);
                });
            });
        WilleModal.setContent(content);
        WilleModal.build();
    },
}

$(document).ready(function () {
    ExtAres.init();
});